module.exports = __webpack_public_path__ + "70e7065f0e437e75456f592c3feb97e2.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/header-logo.png
// module id = 132
// module chunks = 0